import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { 
  getToken, 
  // getIsAdminLogin 
} from "./Utils/Common";

import './App.css';
import './CssFiles/CommonStyles/CommonStyles.css';
import './CssFiles/CustomStyles/CustomStyles.css';
import './CssFiles/Responsiveness/Responsiveness.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Property from "./Pages/Property/Property";

import RentalUnit from "./Pages/RentalUnit/RentalUnit";
import AddRentalUnit from "./Pages/RentalUnit/AddRentalUnit";
import ViewEditRentalUnit from "./Pages/RentalUnit/ViewEditRentalUnit";
import RentalUnitHistory from "./Pages/RentalUnit/RentalUnitHistory";

import Parking from "./Pages/Parking/Parking";
import ParkingHistory from "./Pages/Parking/ParkingHistory";
import EditAddParking from "./Pages/Parking/EditAddParking";
import ContractParking from "./Pages/Parking/ContractParking";

import Users from "./Pages/Users/Users";

import Tenants from "./Pages/Tenants/Tenants";
import AddEditTenants from "./Pages/Tenants/AddEditTenants";
import RenewContracts from "./Pages/Tenants/RenewContracts";
import EditTenantRate from "./Pages/Tenants/EditTenantRate";
import TenantHistory from "./Pages/Tenants/TenantHistory";
import MoveOutTenants from "./Pages/Tenants/MoveOutTenants";
import DebitSOA from "./Pages/Tenants/DebitSOA";

import Owner from "./Pages/Owner/Owner";
import AddOwner from "./Pages/Owner/AddEditOwner";

import SecurityDesposits from "./Pages/SecurityDeposits/SecurityDesposits";

import AdvanceRental from "./Pages/Advance Rental/AdvanceRental";

import ConstructionBond from "./Pages/Construction Bonds/ConstructionBond";

import ElectricityMeterReadings from "./Pages/Meter Readings/ElectricityMeterReadings";
import GasMeterReading from "./Pages/Meter Readings/GasMeterReading";
import WaterMeterReading from "./Pages/Meter Readings/WaterMeterReading";
import ViewReading from "./Pages/Meter Readings/ViewReading";
import AddReading from "./Pages/Meter Readings/AddReading";

import Billing from "./Pages/Billings/Billing";
import OwnerBilling from "./Pages/Billings/OwnerBilling";
import AddBilling from "./Pages/Billings/AddBilling";
import BillingItems from "./Pages/Billings/BillingItems";
import DiscountItems from "./Pages/Billings/DiscountItems";
import PreviewBilling from "./Pages/Billings/PreviewBilling";
import PreviewParkingBilling from "./Pages/Billings/PreviewParkingBilling";

import Payments from "./Pages/Payments/Payments";
import ParkingPayments from "./Pages/Payments/ParkingPayments";
import OwnerPayment from "./Pages/Payments/OwnerPayment";
import AddPayment from "./Pages/Payments/AddPayment";
import AddParkingPayment from "./Pages/Payments/AddParkingPayment";
import PreviewPayment from "./Pages/Payments/PreviewPayment";
import PreviewParkingPayment from "./Pages/Payments/PreviewParkingPayment";

import Suppliers from "./Pages/Suppliers/Suppliers";

import MonthlyCollection from "./Pages/TenantReports/MonthlyCollection";
import MonthlyPayment from "./Pages/TenantReports/MonthlyPayment";
import ReceivableReport from "./Pages/TenantReports/ReceivableReport";
import MonthlyOwnerIncome from "./Pages/TenantReports/MonthlyOwnerIncome";
import MonthlyManagementIncome from "./Pages/TenantReports/MonthlyManagementIncome";
import PreviewOwnerIncome from "./Pages/TenantReports/PreviewOwnerIncome";

import Exhibitors from "./Pages/Exhibitors/Exhibitors";
import AddExhibitors from "./Pages/Exhibitors/AddExhibitors";
import EditViewExhibitors from "./Pages/Exhibitors/EditViewExhibitors";
import ExhibitorsBilling from "./Pages/Exhibitors/ExhibitorsBilling";
import AddExhibitorsBilling from "./Pages/Exhibitors/AddExhibitorsBilling";
import EditViewExhibitorsBilling from "./Pages/Exhibitors/EditViewExhibitorsBilling";
import PrintPreviewExhibitorsBilling from "./Pages/Exhibitors/PrintPreviewExhibitorsBilling";
import ExhibitorsPayment from "./Pages/Exhibitors/ExhibitorsPayment";
import AddExhibitorsPayment from "./Pages/Exhibitors/AddExhibitorsPayment";
import PrintPreviewExhibitorsPayment from "./Pages/Exhibitors/PrintPreviewExhibitorsPayment";

import Expense from "./Pages/Expense/Expense";
import ParkingExpense from "./Pages/Expense/ParkingExpense";
import AddEditExpense from "./Pages/Expense/AddEditExpense";
import PreviewExpense from "./Pages/Expense/PreviewExpense";

import ExhibitorPaymentReport from "./Pages/Reports/ExhibitorPaymentReport";
import ExhibitorReceivableReport from "./Pages/Reports/ExhibitorReceivableReport";

import TaskPersonnel from "./Pages/TaskManager/TaskPersonnel";
import TaskCategory from "./Pages/TaskManager/TaskCategory";
import TaskManager from "./Pages/TaskManager/TaskManager";
import AddEditTaskManager from "./Pages/TaskManager/AddEditTaskManager";

import { Toaster } from 'react-hot-toast';
import AddEditContract from "./Pages/Parking/AddEditContract";
import ParkingBilling from "./Pages/Billings/ParkingBilling";
import AddParkingBilling from "./Pages/Billings/AddParkingBilling";
import ParkingContractHistory from "./Pages/Parking/ParkingContractHistory";
import TaskCalendar from "./Pages/TaskManager/TaskCalendar";
function App() {
  const userToken = getToken();
  // const isAdmin = getIsAdminLogin();

  const toastOptions = {
    duration: 3000,
    style: {
      fontFamily: 'var(--font-regular)',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.9)', 
      color: '#fff', 
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out', 
    },
    success: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(65, 184, 131, 0.9)', 
      },
    },
    error: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(255, 99, 71, 0.9)', 
      },
    },
  };
  
  return (
    <div className="page">
      <Toaster position="top-right" toastOptions={toastOptions} />
      <Router>
        <Routes>
          <Route path="/" element={userToken ? <Dashboard/> : <Login/>} />
          {/* <Route path="/login" element={<Login/>} /> */}
          <Route path="/dashboard" element={userToken ? <Dashboard /> : <Login />} /> {/* Line added by Gab */}
          <Route path="/property" element={userToken ? <Property/> : <Login/>} />

          <Route path="/rental-unit" element={userToken ? <RentalUnit/> : <Login/>} />
          <Route path="/rental-unit/add" element={userToken ? <AddRentalUnit/> : <Login/>} />
          <Route path="/rental-unit/edit/:id" element={userToken ? <ViewEditRentalUnit/> : <Login/>} />
          <Route path="/rental-unit/history" element={userToken ? <RentalUnitHistory/> : <Login/>} />

          <Route path="/parking" element={userToken ? <Parking/> : <Login/>} />
          <Route path="/parking/:type/:id?" element={userToken ? <EditAddParking/> : <Login/>} />
          <Route path="/parking/history" element={userToken ? <ParkingHistory/> : <Login/>} />
          <Route path="/parking-contract" element={userToken ? <ContractParking/> : <Login/>} />
          <Route path="/parking-contract/history/:id" element={userToken ? <ParkingContractHistory /> : <Login/>} />
          <Route path="/parking-contract/:type/:id?" element={userToken ? <AddEditContract/> : <Login/>} />

          <Route path="/tenant" element={userToken ? <Tenants /> : <Login/>} />
          <Route path="/tenant/move-out/:id" element={userToken ? <MoveOutTenants /> : <Login/>} />
          <Route path="/tenant/:type/:id?" element={userToken ? <AddEditTenants /> : <Login/>} />
          <Route path="/tenant/rate/:id" element={userToken ? <EditTenantRate /> : <Login/>} />
          <Route path="/contract-renew/:type/:id" element={userToken ? <RenewContracts/> : <Login/>} />
          <Route path="/tenant/history/:id" element={userToken ? <TenantHistory /> : <Login/>} />
          <Route path="/tenant/print-soa/:type/:id" element={userToken ? <DebitSOA /> : <Login/>} />

          <Route path="/owner" element={userToken ? <Owner /> : <Login/>} />
          <Route path="/owner/add" element={userToken ? <AddOwner /> : <Login/>} />
          <Route path="/owner/edit/:id" element={userToken ? <AddOwner /> : <Login/>} />

          <Route path="/security-deposit" element={userToken ? <SecurityDesposits /> : <Login/>} />

          <Route path="/advance-rental" element={userToken ? <AdvanceRental /> : <Login/>} />

          <Route path="/construction-bond" element={userToken ? <ConstructionBond /> : <Login/>} />

          <Route path="/electric-reading" element={userToken ? <ElectricityMeterReadings /> : <Login/>} />
          <Route path="/gas-reading" element={userToken ? <GasMeterReading /> : <Login/>} />
          <Route path="/water-reading" element={userToken ? <WaterMeterReading /> : <Login/>} />
          <Route path="/view-reading/:type/:id" element={userToken ? <ViewReading /> : <Login/>} />
          <Route path="/add-reading/:type" element={userToken ? <AddReading /> : <Login/>} />

          <Route path="/billing" element={userToken ? <Billing /> : <Login/>} />
          <Route path="/owner-billing" element={userToken ? <OwnerBilling /> : <Login/>} />
          <Route path="/parking-billing" element={userToken ? <ParkingBilling /> : <Login/>} />
          <Route path="/add-billing/:type" element={userToken ? <AddBilling /> : <Login/>} />
          <Route path="/add-parking-billing/:type" element={userToken ? <AddParkingBilling /> : <Login/>} />
          <Route path="/billing-item" element={userToken ? <BillingItems /> : <Login/>} />
          <Route path="/discount-item" element={userToken ? <DiscountItems /> : <Login/>} />
          <Route path="/preview-billing/:type/:id" element={userToken ? <PreviewBilling /> : <Login/>} />
          <Route path="/preview-parking-billing/:type/:id" element={userToken ? <PreviewParkingBilling /> : <Login/>} />

          <Route path="/tenant-payment" element={userToken ? <Payments /> : <Login/>} />
          <Route path="/owner-payment" element={userToken ? <OwnerPayment /> : <Login/>} />
          <Route path="/parking-payment" element={userToken ? <ParkingPayments /> : <Login/>} />
          <Route path="/add-payment/:type" element={userToken ? <AddPayment /> : <Login/>} />
          <Route path="/add-parking-payment/:type" element={userToken ? <AddParkingPayment /> : <Login/>} />
          <Route path="/preview-payment/:type/:id" element={userToken ? <PreviewPayment /> : <Login/>} />
          <Route path="/preview-parking-payment/:type/:id" element={userToken ? <PreviewParkingPayment /> : <Login/>} />

          <Route path="/supplier" element={userToken ? <Suppliers /> : <Login/>} />

          <Route path="/monthly-collection" element={userToken ? <MonthlyCollection /> : <Login/>} />
          <Route path="/monthly-payment" element={userToken ? <MonthlyPayment /> : <Login/>} />
          <Route path="/receivable-report" element={userToken ? <ReceivableReport /> : <Login/>} />
          <Route path="/owner-income" element={userToken ? <MonthlyOwnerIncome /> : <Login/>} />
          <Route path="/management-income" element={userToken ? <MonthlyManagementIncome /> : <Login/>} />
          <Route path="/owner-income/preview/:type/:unitId/:id" element={userToken ? <PreviewOwnerIncome /> : <Login/>} />

          <Route path="/exhibitor" element={userToken ? <Exhibitors /> : <Login/>} />
          <Route path="/add-exhibitor" element={userToken ? <AddExhibitors /> : <Login/>} />
          <Route path="/edit-exhibitor" element={userToken ? <EditViewExhibitors /> : <Login/>} />
          <Route path="/exhibitor-billing" element={userToken ? <ExhibitorsBilling /> : <Login/>} />
          <Route path="/add-exhibitor-billing" element={userToken ? <AddExhibitorsBilling /> : <Login/>} />
          <Route path="/edit-exhibitor-billing" element={userToken ? <EditViewExhibitorsBilling /> : <Login/>} />
          <Route path="/preview-exhibitor-billing" element={userToken ? <PrintPreviewExhibitorsBilling /> : <Login/>} />
          <Route path="/exhibitor-payment" element={userToken ? <ExhibitorsPayment /> : <Login/>} />
          <Route path="/add-exhibitor-payment" element={userToken ? <AddExhibitorsPayment /> : <Login/>} />
          <Route path="/preview-exhibitor-payment" element={userToken ? <PrintPreviewExhibitorsPayment /> : <Login/>} />

          <Route path="/expense" element={userToken ? <Expense /> : <Login/>} />
          <Route path="/parking-expense" element={userToken ? <ParkingExpense /> : <Login/>} />
          <Route path="/manage-expense/:form/:label/:id?" element={userToken ? <AddEditExpense /> : <Login/>} />
          <Route path="/expense/preview/:form/:id" element={userToken ? <PreviewExpense /> : <Login/>} />

          <Route path="/exhibitor-payment-report" element={userToken ? <ExhibitorPaymentReport /> : <Login/>} />
          <Route path="/exhibitor-receivable-report" element={userToken ? <ExhibitorReceivableReport /> : <Login/>} />

          <Route path="/task-personnel" element={userToken ? <TaskPersonnel/> : <Login/>} />
          <Route path="/task-category" element={userToken ? <TaskCategory /> : <Login/>} />
          <Route path="/task-manager" element={userToken ? <TaskManager /> : <Login/>} />
          <Route path="/task-manager/:type/:id?" element={userToken ? <AddEditTaskManager /> : <Login/>} />
          <Route path="/task-calendar" element={userToken ? <TaskCalendar /> : <Login/>} />

          <Route path="/user" element={userToken ? <Users/> : <Login/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
